import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-box-body" }
const _hoisted_2 = ["model"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "caption"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-xs-12" }
const _hoisted_10 = {
  type: "submit",
  class: "btn btn-primary"
}

import { reactive, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import router from '@/router';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const formData = reactive({
	account: '',
	password: '',
});

const captionMessage = ref('');

async function Submit(e: Event) {
	e.preventDefault();
	const login = await store.dispatch('app/login', {
		account: formData.account,
		password: formData.password,
	});

	if (login.result) {
		//router.go(0);
		router.push('/adminlist');
	} else {
		captionMessage.value = login.message;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      method: "post",
      target: "hid_proc",
      model: formData,
      onSubmit: Submit
    }, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.account) = $event)),
          name: "account",
          class: "form-control",
          placeholder: _unref(t)('board.write.placeholder.id'),
          required: ""
        }, null, 8, _hoisted_4), [
          [_vModelText, formData.account]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "material-symbols-outlined" }, "person", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.password) = $event)),
          name: "password",
          class: "form-control",
          placeholder: _unref(t)('board.write.placeholder.pwd'),
          required: ""
        }, null, 8, _hoisted_6), [
          [_vModelText, formData.password]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "material-symbols-outlined" }, "Lock", -1))
      ]),
      _createElementVNode("div", null, [
        (captionMessage.value)
          ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(captionMessage.value), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", _hoisted_10, _toDisplayString(_unref(t)('common.login')), 1)
        ])
      ])
    ], 40, _hoisted_2)
  ]))
}
}

})